














import { Vue, Component, Prop } from 'vue-property-decorator'
import { keybindToSymbols } from '@/util/Helpers'

@Component({ name: 'keybind-input' })
export default class KeybindInput extends Vue {
    @Prop({ type: String, required: true })
    value!: string

    get symbols(): string {
        return keybindToSymbols(this.value)
    }

    onKeypress(event: KeyboardEvent): void {
        event.preventDefault()
        event.stopPropagation()

        if (event.key === 'Backspace' || event.key === 'Delete') {
            this.$emit('input', '')
            return
        }

        let value = ''
        if (event.ctrlKey) value += 'Ctrl+'
        if (event.altKey) value += 'Option+'
        if (event.shiftKey) value += 'Shift+'
        if (event.metaKey) value += 'Cmd+'
        if (!['meta', 'control', 'shift', 'alt'].includes(event.key.toLowerCase())) {
            value += event.key.toLowerCase()
        }
        this.$emit('input', value)
    }

    onFocus(): void {
        window.addEventListener('keydown', this.onKeypress)
    }

    onBlur(): void {
        window.removeEventListener('keydown', this.onKeypress)
    }

    destroyed(): void {
        window.removeEventListener('keydown', this.onKeypress)
    }
}
